<div class="grid gap-4 grid-cols-1 xl:grid-cols-2 m-4" *ngIf="isLoaded">
    <div>
        <card-component headerTitle="Général">
            <app-dossier-v2
                [currentDossierIntervention]="currentDossierIntervention"
                [users]="users"
                (valueChanged)="onValueChanged($event)"
            >
            </app-dossier-v2>
        </card-component>
    </div>
    <div>
        <card-component headerTitle="Communications">
            <app-communication
                [currentDossierIntervention]="currentDossierIntervention"
                [users]="users"
            >
            </app-communication>
        </card-component>
    </div>
    <div>
        <card-component headerTitle="Équipements" class="col-span-2">
            <div class="flex shrink-0 items-center sm:ml-4" ngProjectAs="actions">
                <button class="ml-4" mat-flat-button [color]="'primary'" (click)="openEquipementModal()">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1">Ajouter</span>
                </button>
            </div>
            <app-equipement-v2
                [currentDossierIntervention]="currentDossierIntervention"
                [piecesEquipements]="piecesEquipements"
                [nomsPieces]="nomsPieces"
                (refreshPieces)="getPiecesEquipementsLaisse()"
            >
            </app-equipement-v2>
        </card-component>
    </div>
    <div>
        <card-component headerTitle="Plan">
            <app-etage-v2 [idDossierIntervention]="idDossierIntervention" [currentFicheIntervention]="currentFicheIntervention"></app-etage-v2>
        </card-component>
    </div>
    <div>
        <card-component headerTitle="Pièces">
            <div class="flex shrink-0 items-center sm:ml-4" ngProjectAs="actions">
                <button (click)="openPieceModal()" class="ml-4" mat-flat-button [color]="'primary'">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1">Ajouter</span>
                </button>
            </div>
            <app-piece-v2
                [pieces]="pieces"
                [niveaux]="niveaux"
                [idDossierIntervention]="idDossierIntervention"
                [currentFicheIntervention]="currentFicheIntervention"
                (editPiece)="openPieceModal($event)"
                (refresh)="fetchPieces()"
            ></app-piece-v2>
        </card-component>
    </div>

</div>
